module.exports = __webpack_public_path__ + "static/employee-scheduling-time-clock-app2-765cf008fc70d6f88e7a98747470147c.svg";